/* Port City extras: hero slider + carry upsell reminder. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Hero slider ---------------- */
  document.querySelectorAll('[data-pch-slider]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.pch-slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var pauseBtn = root.querySelector('[data-pause]');
    if (slides.length < 2) return;
    var i = 0, timer = null, hover = false, userPaused = reduce;
    var ms = parseInt(root.getAttribute('data-interval'), 10) || 6000;

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        s.querySelectorAll('a,button').forEach(function (el) {
          if (el.classList.contains('pch-slide__media')) return;
          if (on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1');
        });
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
    }
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (userPaused || hover || document.hidden) return;
      timer = setInterval(function () { go(i + 1); }, ms);
    }
    function syncPause() {
      root.classList.toggle('is-paused', userPaused);
      if (pauseBtn) pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
    }
    go(0); syncPause(); start();

    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
    if (next) next.addEventListener('click', function () { go(i + 1); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-dot')); start(); }); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { userPaused = !userPaused; syncPause(); start(); });

    root.addEventListener('mouseenter', function () { hover = true; stop(); });
    root.addEventListener('mouseleave', function () { hover = false; start(); });
    root.addEventListener('focusin', function () { hover = true; stop(); });
    root.addEventListener('focusout', function () { hover = false; start(); });
    document.addEventListener('visibilitychange', start);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(i - 1); start(); }
      if (e.key === 'ArrowRight') { go(i + 1); start(); }
    });

    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? i + 1 : i - 1);
      x0 = null; start();
    }, { passive: true });
  });

  /* ---------------- Carry upsell reminder ---------------- */
  var dlg = document.getElementById('pch-upsell');
  var cfgEl = document.getElementById('pch-upsell-data');
  if (!dlg || !cfgEl) return;
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
  var ccIds = (cfg.ccIds || []).map(String);
  var SHOWN = 'pch_upsell_shown', PENDING = 'pch_upsell_pending';
  var ss = { get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
             set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
             del: function (k) { try { sessionStorage.removeItem(k); } catch (e) {} } };
  var busy = false;

  function open() {
    ss.set(SHOWN, '1'); ss.del(PENDING);
    if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); }
    else dlg.setAttribute('open', '');
    document.documentElement.classList.add('pch-upsell-open');
  }
  function close() {
    if (typeof dlg.close === 'function' && dlg.open) dlg.close(); else dlg.removeAttribute('open');
    document.documentElement.classList.remove('pch-upsell-open');
  }
  dlg.addEventListener('close', function () { document.documentElement.classList.remove('pch-upsell-open'); });
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-upsell-close]')) close();
  });

  function check() {
    if (busy || ss.get(SHOWN)) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var items = c.items || [];
        var hasHolster = items.some(function (it) { return it.product_type === cfg.holsterType; });
        var hasCarry = items.some(function (it) { return ccIds.indexOf(String(it.product_id)) > -1; });
        if (hasHolster && !hasCarry) setTimeout(open, 350);
        else ss.del(PENDING);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function isAdd(url, method) {
    return /\/cart\/add(\.js|\.json)?(\?|$)/.test(String(url || '')) && String(method || 'GET').toUpperCase() === 'POST';
  }

  // Catch AJAX adds from the theme and from apps (Easify etc.).
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var method = (init && init.method) || (input && input.method) || 'GET';
      var p = _fetch.apply(this, arguments);
      if (isAdd(url, method)) {
        p.then(function (res) { if (res && res.ok) check(); }).catch(function () {});
      }
      return p;
    };
  }
  var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this._pchAdd = isAdd(u, m); return XO.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this._pchAdd) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) check(); });
    return XS.apply(this, arguments);
  };

  // Non-AJAX adds redirect to /cart; remember the add so the cart page can show it.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('form[action*="/cart/add"]') && cfg.productType === cfg.holsterType) ss.set(PENDING, '1');
  }, true);
  if (ss.get(PENDING) && !ss.get(SHOWN) && /^\/cart\/?$/.test(location.pathname)) check();

  // One-tap add for single-variant picks (dialog and cart strip).
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-upsell-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true; b.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.getAttribute('data-upsell-add'), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      b.textContent = 'Added \u2713'; b.classList.add('is-added');
      if (/^\/cart\/?$/.test(location.pathname)) setTimeout(function () { location.reload(); }, 600);
      if (typeof window.pchRefreshCart === 'function') window.pchRefreshCart();
      else fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
      });
    }).catch(function () { b.disabled = false; b.textContent = 'Try again'; });
  });
})();
